<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="address-block">
      <sc-text tag="p" class="address" :field="address" />
      <ul class="links-list" v-if="hasLinks">
        <li v-for="(link, index) in links" :key="index">
          <sc-link :field="link.fields.link" />
        </li>
      </ul>
    </div>
  </sc-render>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import ScRender from '../sc-render'

export default {
  name: 'Address',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRender,
    ScText: Text,
    ScLink: Link
  },
  computed: {
    address () {
      return get(this.fields, ['address'], {})
    },
    links () {
      return get(this.fields, ['links'], [])
    },
    hasLinks () {
      return this.links && this.links.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.address-block {
  display: flex;
  flex-direction: column;
  @include inset-space($space-050);
}
.address {
  @include stack-space($space-060);
  @include font('060');
  text-align: left;
}
.links-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  @include inset-space(0);
  li {
    list-style: none;
    @include stack-space($space-050);
  }
}
.links-list a {
  @include fontBold('040');
}

@include tablet() {
  .address-block {
    @include inset-space($space-060);
  }
  .address {
    @include stack-space($space-050);
    text-align: center;
  }
  .links-list {
    flex-direction: row;
    justify-content: center;
    flex-grow: 1;
    li {
      @include stack-space(0);
      @include inline-space($space-050);
    }
  }
}
</style>
